<template>
	<div open question :id="`question-${questionData.number}`" @keyup.enter="submitQuestion">
		<questionheader :questionData="questionData" />
		<div data-question-main>
			<div
				v-for="(answer, index) in questionData.answers"
				:key="`answer-${index}`"
				data-answer
			>
				<div data-answer-container>
					<questioninput
						v-if="answer.type !== `OuterField`"
						:answerData="answer"
						:questionData="questionData"
						:aria-labelledby="`header-${questionData.number}`"
						@element-focused="inputFocus($event, answer)"
						:disabled="!get.editingAllowed(questionData) || outerFieldIsChecked"
					/>
					<answerdescription
						v-if="answer.description !== `` "
						:answerData="answer"
						:questionData="questionData"
					/>
				</div>
				<checkboxradio
					v-if="answer.type === `OuterField`"
					:questionData="questionData"
					:outerfield="true"
					:answerData="answer"
					:showLabel="true"
					type="checkbox"
					@element-click="outerfieldClicked($event, answer)"
				/>
			</div>
		</div>
		<questionfooter :questionData="questionData" />
		<validationpopup :questionValidation="questionValidation" />
	</div>
</template>

<script>
import mixins from "@/global/mixins";

export default {
	name: `open-question`,
	mixins: [mixins.defaultQuestion],
	computed: {
		answersGiven() {
			return this.questionData.answers.filter((answer) => answer.openField !== `` || answer.isChecked).length;
		},
		outerFieldIsChecked: function () {
			return this.questionData.answers[1] !== undefined && this.questionData.answers[1].isChecked;
		}
	},
	methods: {
		// Do things when radio button or selectbox changes it value
		outerfieldClicked: function (e, answer) {
			let inputField = this.questionData.answers[0];
			answer.isChecked = !answer.isChecked;

			// Show and hide values based on whether they are checked. Values have to be stored in another property so they aren't validated when they shouldn't be.
			if (!this.outerFieldIsChecked && inputField.shadowValue !== ``) {
				inputField.isChecked = true;
				inputField.openField = inputField.shadowValue;
			} else if (this.outerFieldIsChecked) {
				inputField.isChecked = false;
				inputField.shadowValue = inputField.openField;
				inputField.openField = ``;
			}
		},
		inputFocus: function (e, answer) {
			// This is for the feature 'Standaard antwoorden'. Only those fields have to be emptied when the user selects them
			if (answer.isEdited === undefined && answer.isDefaultAnswer) {
				answer.openField = "";
				answer.isEdited = true;
			}
		}
	}
};
</script>

<style scoped>
[data-answer] {
	align-items: flex-start;
	flex-direction: column;
}

[data-answer-container] {
	display: flex;
	align-items: center;
	width: 100%;
}
</style>
